import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const AdverseReaction = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Adverse Reaction</InputLabel>
      <Select
        value={moduleValues?.['Adverse Reaction'] ?? ''}
        label="Adverse Reaction"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Adverse Reaction']: e.target.value,
          }))
        }
      >
        {[
          'None',
          'Apnoea',
          'Airway Obstruction',
          'Hypotension',
          'Vomiting / Aspiration',
          'Emergence Phenomenon',
          'Agitation on Recovery',
          'Other',
        ].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default AdverseReaction
